/** Показывать баннер stale-контента при сбое обновления уроков (roadmap §3A). */
export function shouldShowLessonsOfflineBanner(
  sectionsCount: number,
  lessonsRefreshFailed: boolean
): boolean {
  return sectionsCount > 0 && lessonsRefreshFailed;
}
